export default { sha: '47f03e0a80ad98764def94956687fd75a4aa2655', buildNumber: 'undefined' }
